export interface StreamOffsetSources {
  simulivePositionSeconds?: number | null;
  livePositionSeconds?: number | null;
  elapsedSinceBroadcastStartMs?: number | null;
}

function toWholeSeconds(value: number | null | undefined): number | undefined {
  if (value == null || !Number.isFinite(value) || value < 0) {
    return undefined;
  }
  return Math.floor(value);
}

// Undefined rather than 0 when no source is usable: 0 would aggregate as "reacted at the start".
export function resolveStreamOffsetSeconds(sources: StreamOffsetSources): number | undefined {
  const elapsedMs = sources.elapsedSinceBroadcastStartMs;

  return (
    toWholeSeconds(sources.simulivePositionSeconds) ??
    toWholeSeconds(sources.livePositionSeconds) ??
    toWholeSeconds(elapsedMs == null ? undefined : elapsedMs / 1000)
  );
}
